import { CourseUI } from '@shared';
import { useQuery } from '@tanstack/react-query';
import { coursesApi } from 'App';

type Args = {
  partner: string;
  course: string;
};

type CourseTypes = coursesApi.CourseAPI | CourseUI;

function isCourseUI(course: CourseTypes): course is CourseUI {
  return Object.hasOwn(course, 'name');
}

export function useCourse({ partner, course }: Args): string {
  const { data } = useQuery(['course', course], () => coursesApi.get(partner, course), {
    select: (course: CourseTypes) => {
      if (isCourseUI(course)) {
        // when data comes from cached courses it's transformed for UI already
        return course.name;
      }

      // when data comes from api request
      const { course: courseAPI } = course;
      return courseAPI.name;
    },
  });
  return data || 'Name was not found';
}
